'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const GOOGLE_VIEWER_SRC = 'https://docs.google.com/viewer?embedded=true&url=';
const OFFICE_VIEWER_SRC = 'https://view.officeapps.live.com/op/embed.aspx?src=';
const StandardDocPreview = ({ attachment , ...otherProps })=>{
    const src = attachment.extension === 'csv' || attachment.size >= 5000000 ? GOOGLE_VIEWER_SRC : OFFICE_VIEWER_SRC;
    const aspectRatio = attachment ? `${attachment.width} / ${attachment.height}` : 'auto';
    const url = new URL(attachment.cdn_url || attachment.url || '');
    const urlWithoutQueryParams = url.href.replace(url.search, '');
    return /*#__PURE__*/ React__default.default.createElement("iframe", _extends({
        src: `${src}${urlWithoutQueryParams}`,
        style: {
            aspectRatio,
            border: 0
        },
        title: attachment.filename,
        width: "100%",
        height: "auto"
    }, otherProps));
};

exports.GOOGLE_VIEWER_SRC = GOOGLE_VIEWER_SRC;
exports.OFFICE_VIEWER_SRC = OFFICE_VIEWER_SRC;
exports.StandardDocPreview = StandardDocPreview;
//# sourceMappingURL=standard-doc-preview.js.map
